// Conservative, deterministic grouping for the existing decision lanes.
// Never merge across lanes, categories, or different problem intents.
const STOP = new Set(['the','and','this','that','with','from','when','then','user','users','please','cannot','cant','have','does','would','should','need','want','there','their','your','into','about','page','feature','request']);
const TOKENS = s => new Set(String(s || '').toLowerCase().replace(/[^a-z0-9 ]/g,' ').split(/\s+/).filter(w => w.length > 2 && !STOP.has(w)));
const JACCARD = (a,b) => { const common=[...a].filter(x=>b.has(x)).length;return common / (a.size+b.size-common || 1); };
const INTENTS = [
  ['broken',/\b(broken|fails?|failing|error|crash|not working|doesn't work|cannot|can't|unable)\b/i],
  ['slow',/\b(slow|latency|lag|loading|timeout|takes forever)\b/i],
  ['new',/\b(add|support|integrate|integration|new feature|would like|request)\b/i],
];
function intent(text){return INTENTS.find(([,pattern])=>pattern.test(text||''))?.[0] || 'general';}
function textOf(d){return d?.signal?.text || d?.summary || '';}
function categoryOf(d){return d?.category || 'other';}
export function clusterLane(decisions) {
  const groups=[];
  for(const decision of decisions||[]){
    const text=textOf(decision), tokens=TOKENS(text), label=intent(text), category=categoryOf(decision);
    // Require 2 meaningful shared terms, not a lone common word like "export".
    const match=groups.find(g=>g.category===category && g.intent===label &&
      [...tokens].filter(t=>g.tokens.has(t)).length>=2 && JACCARD(tokens,g.tokens)>=0.48);
    if(match){match.members.push(decision);}
    else groups.push({id:decision.signal_id,category,intent:label,tokens,members:[decision]});
  }
  return groups.map(({id,members})=>({
    id,
    title:members[0].summary || textOf(members[0]).slice(0,100) || 'Untitled issue',
    members,
    count:members.length,
    needsReview:members.length>1,
    // A grouped count is reports, NEVER unique users.
    reportCount:members.length,
    sources:[...new Set(members.map(m=>m.signal?.source).filter(Boolean))],
  }));
}
